import { useState } from "react";
function useFlashPopover(options = {}) {
  const { togglerRef, closeOnOutsideClick = !0 } = options, [isOpen, setIsOpen] = useState(!1);
  function open() {
    setIsOpen(!0);
  }
  function close() {
    setIsOpen(!1);
  }
  function toggle() {
    setIsOpen((prev) => !prev);
  }
  function onOutsideClick(ev) {
    closeOnOutsideClick && (togglerRef != null && togglerRef.current && togglerRef.current.contains(ev.target) || close());
  }
  return {
    isOpen,
    open,
    close,
    toggle,
    onOutsideClick
  };
}
export {
  useFlashPopover
};
//# sourceMappingURL=useFlashPopover.js.map
